function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.114 1.623l21.36 16.3-5.283 8.727-21.36-16.428 5.283-8.6z",
  fill: "url(#SUSHI_svg__paint0_linear_1_86)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.473 17.922c-1.837 2.953-8.038 1.797-13.895-2.823C8.606 10.607 5.39 4.574 7.113 1.622 8.951-1.33 15.152-.174 21.01 4.446c5.971 4.364 9.187 10.525 7.464 13.476z",
  fill: "url(#SUSHI_svg__paint1_linear_1_86)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.19 26.522c-1.837 2.952-8.038 1.797-13.895-2.824-5.856-4.62-9.187-10.524-7.35-13.604 1.838-2.952 8.04-1.797 13.896 2.823 5.857 4.62 9.072 10.653 7.35 13.605z",
  fill: "url(#SUSHI_svg__paint2_linear_1_86)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.473 17.923l-5.282 8.727c-1.838 2.952-8.039 1.669-13.896-2.823a35.515 35.515 0 01-3.215-2.824c.804-.128 1.837-.642 2.87-1.925 1.838-2.182 2.757-2.695 3.56-2.567.805 0 1.723.898 3.216 3.08s3.56 2.824 4.823 1.669c.115-.129.23-.129.345-.257 1.034-.898 1.378-1.284 3.33-5.39.46-1.027 2.067-2.696 4.25-1.926.573 1.669.573 3.08 0 4.236z",
  fill: "#0E0F23"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.67 17.41c-1.609 2.566-7.236 1.283-12.633-2.953-5.512-4.235-8.728-9.626-7.12-12.193C9.525-.303 15.152.981 20.55 5.216c5.398 4.236 8.613 9.626 7.12 12.193z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M22.616 13.559c-.803 1.284-3.56.642-6.316-1.412-2.64-2.053-4.249-4.749-3.445-6.032.804-1.284 3.56-.642 6.316 1.412 2.642 2.053 4.25 4.748 3.445 6.032z",
  fill: "#CF65AE"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.654 4.574c0-.128-.115-.256-.23-.128-.114.128-.23.128-.23.257.116.385.23.641.23.898 0 .128.115.257.23.128.115 0 .23-.128.115-.256 0-.257 0-.514-.115-.899zM7.228 6.628c0-.129-.115-.257-.23-.129-.114.129-.114.129-.114.257 1.263 3.209 3.904 6.674 7.35 9.241.114.128.229 0 .344 0 .115-.128 0-.257 0-.385-3.56-2.567-6.087-5.904-7.35-8.984zM21.124 19.206c-.115 0-.23 0-.23.128 0 .129 0 .257.115.257.344.128.804.257 1.148.385.115 0 .23 0 .23-.128 0-.129 0-.257-.115-.257-.344-.128-.804-.257-1.148-.385zM23.19 19.72c-.114 0-.229.128-.229.256s.115.257.23.257c.918.128 1.952.256 2.756.128.115 0 .23-.128.23-.257 0-.128-.115-.256-.23-.256-.919.128-1.838 0-2.756-.129z",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "SUSHI_svg__paint0_linear_1_86",
  x1: 11.304,
  y1: -0.697,
  x2: 16.494,
  y2: 15.249,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#03B8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FA52A0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SUSHI_svg__paint1_linear_1_86",
  x1: 14.774,
  y1: -1.827,
  x2: 19.965,
  y2: 14.12,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#03B8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FA52A0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SUSHI_svg__paint2_linear_1_86",
  x1: 7.874,
  y1: 0.419,
  x2: 13.065,
  y2: 16.366,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#03B8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FA52A0"
})));

function SvgSushi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

export default __webpack_public_path__ + "e8f7520dab767722cd6555b96c10cd41.svg";
export { SvgSushi as ReactComponent };